// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1wie5","header":"MergedInvoice_header__3gnfB"};